import { AutoMap } from "@automapper/classes";

export class LimitCategoryDTO {

    @AutoMap()
    code: string = ''
    @AutoMap()
    name: string = '';
    @AutoMap()
    isActive: boolean = false;
    @AutoMap()
    foreColor: string = '';
    @AutoMap()
    backColor: string = '';
    @AutoMap()
    outOfLimitForeColor: string = '';
    @AutoMap()
    outOfLimitBackColor: string = '';
}